import React from 'react';
import {observer} from 'mobx-react';
import {NumberInput, PanelTooltip} from 'shared/components';
import {FormattedMessage} from 'react-intl';
import {types} from 'main/tools';

const ManualHours = observer(({model, uiState}) => {
  const {canCreateEntries} = uiState;

  if (model._type === types.TIME_OFF.ABSENCE) {
    return <span className=''>{parseFloat(model.amount)} <span className={'jumbo'}>({uiState.typeNameById(String(model.typeId))})</span></span>;
  }

  if (model._type === types.HOLIDAY) {
    return <div className='bold'>{model.name}</div>;
  }

  if (!canCreateEntries) {
    return <div className='right-align pr1'>{model.hours}</div>;
  }

  return (
    <div className='relative'>
      <NumberInput
        className={uiState.manuallyEnteredHoursChangedSinceApproval(model) && 'bg-caution'}
        value={model.hours}
        disabled={!!model.startTime}
        onChange={e => uiState.updateEntry(model, {manuallyEnteredHours: e.target.value})}
        style={uiState.manuallyEnteredHoursChangedSinceApproval(model) ? {paddingRight: '1.5rem'} : {}}
      />
      {uiState.manuallyEnteredHoursChangedSinceApproval(model) &&
        <div className='absolute' style={{lineHeight: 0, top: '11px', right: '8px'}}>
          <PanelTooltip>
            {model.approvedManuallyEnteredHours !== null ?
              <div style={{lineHeight: 1}}>
                <div className='pb2'>
                  <FormattedMessage id={'time_tracking.timesheet.EDITED_AFTER_APPROVAL'}/>
                </div>
                <div>
                  <FormattedMessage id={'time_tracking.timesheet.PREVIOUS_VALUE'}
                                    values={{time: <span className='bold'>{model.approvedManuallyEnteredHours}</span>}}/>
                </div>
              </div> :
              <div style={{lineHeight: 1.42857143}}>
                <FormattedMessage id={'time_tracking.timesheet.ADDED_AFTER_APPROVAL'}/>
              </div>
            }
          </PanelTooltip>
        </div>
      }
      {(model.saveStatus === 'saved' || model.saveStatus === 'fadingAway') && <div className={`h6 jumbo absolute ${model.saveStatus === 'fadingAway' ? 'fade-away' : ''}`}>
        <FormattedMessage id='time_tracking.timesheet.Saved'/>
      </div>}
    </div>
  );
});

export default ManualHours;
